/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Templates_EmptyInputs */



/**
* | output |
* | --- |
* | "No templates yet. Upload your company's PowerPoint template and decks are exported inside its own layouts." |
*
* @param {Presentation_Templates_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_templates_empty = /** @type {((inputs?: Presentation_Templates_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Templates_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Vorlagen. Laden Sie die PowerPoint-Vorlage Ihres Unternehmens hoch – Präsentationen werden dann in deren eigene Layouts exportiert.")
	return /** @type {LocalizedString} */ ("No templates yet. Upload your company's PowerPoint template and decks are exported inside its own layouts.")
});